import { message } from 'antd';
import {
  getClass,
  getWeekList,
  getCollectData,
  getWeekType,
  modifyCourse,
  getClassCourse,
  getSelectUser,
  courseList,
} from '../services/manage';
import { getPeriod } from '../services/lessonSet';
import { setManageListData, formatTreeData, getInitWeek } from '../utils';

const initState = {
  // 分页信息
  pageInfo: {
    page: 1,
    pageSize: 10,
    totalElements: 0,
    totalPages: 1,
  },
  // 加载信息
  spinProps: {
    spinning: false,
    tip: '加载中...',
  },
  courseData: [],
  allData: [],
  formData: {
    modifyType: 1,
    selectSignature: '',
  },
  modifyVisible: false,
  searchCourseList: [],
  searchClassList: [],
  classList: [],
  searchWeekList: [],
  defaultCourseId: '',
  defaultWeekId: '',
  defaultClassId: [],
  weekType: [],
  classCourse: [],
  selectUser: {},
};

export default {
  namespace: 'courseManage',
  state: initState,
  effects: {
    *fetchInit({ params }, { call, put }) {
      try {
        yield put({
          type: 'saveState',
          payload: {
            spinProps: {
              spinning: true,
              tip: '加载中...',
            },
          },
        });
        const response = yield call(courseList, params);
        const defaultCourseId = response ? response[0].id : '';
        const classData = yield call(getClass, { termId: defaultCourseId });
        const weekData = yield call(getWeekList, { termId: defaultCourseId });

        yield put({
          type: 'saveState',
          payload: {
            spinProps: {
              spinning: false,
              tip: '加载中...',
            },
            searchCourseList: response,
            defaultCourseId: response ? response[0].id : '',
            searchClassList: formatTreeData(classData),
            classList: classData,
            defaultClassId: [0],
            searchWeekList: weekData,
            defaultWeekId: getInitWeek(weekData),
          },
        });

        return Promise.resolve(response);
      } catch (error) {
        yield put({
          type: 'saveState',
          payload: {
            spinProps: {
              spinning: false,
              tip: '加载中...',
            },
          },
        });
        return Promise.reject(error.msg || '网络错误，请重试');
      }
    },
    *fetchWeekAndClass({ params }, { call, put }) {
      try {
        // yield put({
        //   type: 'saveState',
        //   payload: {
        //     spinProps: {
        //       spinning: true,
        //       tip: '加载中...',
        //     },
        //   },
        // });

        const classData = yield call(getClass, params);
        const weekData = yield call(getWeekList, params);

        yield put({
          type: 'saveState',
          payload: {
            // spinProps: {
            //   spinning: false,
            //   tip: '加载中...',
            // },
            searchClassList: formatTreeData(classData),
            classList: classData,
            defaultClassId: [0],
            searchWeekList: weekData,
            defaultWeekId: getInitWeek(weekData),
            defaultCourseId: params.termId,
          },
        });

        return Promise.resolve();
      } catch (error) {
        // yield put({
        //   type: 'saveState',
        //   payload: {
        //     spinProps: {
        //       spinning: false,
        //       tip: '加载中...',
        //     },
        //   },
        // });
        return Promise.reject(error.msg || '网络错误，请重试');
      }
    },
    *fetchWeekType({ params }, { call, put }) {
      try {
        yield put({
          type: 'saveState',
          payload: {
            spinProps: {
              spinning: true,
              tip: '加载中...',
            },
          },
        });
        const response = yield call(getWeekType, params);
        const arr = [];
        response.forEach(item => {
          arr.push({ ...item, label: item.message, value: item.message });
        });

        yield put({
          type: 'saveState',
          payload: {
            spinProps: {
              spinning: false,
              tip: '加载中...',
            },
            weekType: arr,
          },
        });
      } catch (error) {
        yield put({
          type: 'saveState',
          payload: {
            spinProps: {
              spinning: false,
              tip: '加载中...',
            },
          },
        });
      }
    },
    *fetchGetPeriod({ params }, { call, put }) {
      try {
        yield put({
          type: 'saveState',
          payload: {
            spinProps: {
              spinning: true,
              tip: '加载中...',
            },
          },
        });
        const response = yield call(getPeriod, params);

        yield put({
          type: 'saveState',
          payload: {
            spinProps: {
              spinning: false,
              tip: '加载中...',
            },
            courseData: response,
          },
        });
        return Promise.resolve(response);
      } catch (error) {
        yield put({
          type: 'saveState',
          payload: {
            spinProps: {
              spinning: false,
              tip: '加载中...',
            },
          },
        });
        return Promise.reject(error.msg || '网络错误，请重试');
      }
    },
    *fetchCollectData({ params }, { call, put }) {
      try {
        yield put({
          type: 'saveState',
          payload: {
            spinProps: {
              spinning: true,
              tip: '加载中...',
            },
          },
        });
        const response = yield call(getCollectData, params);
        const data = setManageListData(response);
        yield put({
          type: 'saveState',
          payload: {
            spinProps: {
              spinning: false,
              tip: '加载中...',
            },
            pageInfo: {
              page: 1,
              pageSize: 10,
              totalElements: data.length,
              totalPages: 1,
            },
            allData: data,
          },
        });
      } catch (error) {
        yield put({
          type: 'saveState',
          payload: {
            spinProps: {
              spinning: false,
              tip: '加载中...',
            },
          },
        });
      }
    },
    *fetchModifyCourse({ params }, { call, put }) {
      try {
        yield put({
          type: 'saveState',
          payload: {
            spinProps: {
              spinning: true,
              tip: '加载中...',
            },
          },
        });
        yield call(modifyCourse, params);

        yield put({
          type: 'saveState',
          payload: {
            spinProps: {
              spinning: false,
              tip: '加载中...',
            },
            modifyVisible: false,
          },
        });
        message.success('修改成功');
        return Promise.resolve();
      } catch (error) {
        yield put({
          type: 'saveState',
          payload: {
            spinProps: {
              spinning: false,
              tip: '加载中...',
            },
          },
        });
        return Promise.reject(error.msg || '网络错误，请重试');
      }
    },
    *fetchClassCourse({ params }, { call, put }) {
      try {
        yield put({
          type: 'saveState',
          payload: {
            spinProps: {
              spinning: true,
              tip: '加载中...',
            },
          },
        });
        const response = yield call(getClassCourse, params);
        const arr = [];
        response.forEach(item => {
          arr.push({ label: item, value: item });
        });
        yield put({
          type: 'saveState',
          payload: {
            spinProps: {
              spinning: false,
              tip: '加载中...',
            },
            classCourse: arr,
          },
        });
        return Promise.resolve(response);
      } catch (error) {
        yield put({
          type: 'saveState',
          payload: {
            spinProps: {
              spinning: false,
              tip: '加载中...',
            },
          },
        });
        return Promise.reject(error.msg || '网络错误，请重试');
      }
    },
    *fetchSelectUser({ params }, { call, put }) {
      try {
        yield put({
          type: 'saveState',
          payload: {
            spinProps: {
              spinning: true,
              tip: '加载中...',
            },
          },
        });
        const response = yield call(getSelectUser, params);

        yield put({
          type: 'saveState',
          payload: {
            spinProps: {
              spinning: false,
              tip: '加载中...',
            },
            selectUser: response,
          },
        });
        return Promise.resolve(response);
      } catch (error) {
        yield put({
          type: 'saveState',
          payload: {
            spinProps: {
              spinning: false,
              tip: '加载中...',
            },
          },
        });
        return Promise.reject(error.msg || '网络错误，请重试');
      }
    },
  },

  reducers: {
    saveState(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
    reset() {
      return {
        ...initState,
      };
    },
  },
};
